export default {
  spreadsheetTips: 'Spreadsheet tips',
  tip1: 'Data can be selected and copied to/from any spreadsheet software',
  tip2: 'User-modified values are displayed using',
  thisColor: 'this color',
  tip3: 'When deleting the value of a cell, it will go back to it\'s default value',
  tip4: 'After entering data into a cell, you can press Return to go down or Tab to go right',
  close: 'Close',
  period: 'Period',
  valueVariousUnits: 'Value (various units)',
  externalVariables: 'External variables',
  series: 'Series'
}
